/* globals Backbone */

import { load } from '../service/json';
import getItems from '../service/items';
import VenueSet from '../framework/collections/venue-set';

export default function( $, app ) {
	var $body = $( document.body );

	var {
		model: session,
		views: {
			categoriesList,
			venuesList,
			venueDetails,
			viewItinerary,
			myItinerary: {
				collection: myVenues,
			},
			tripsList: {
				collection: myTrips,
			},
		},
		fetchVenues,
		foundVenues,
	} = app;

	// =========================
	// ! Routing
	// =========================

	var router = new ( Backbone.Router.extend( {
		routes: {
			'categories': 'listCategories',
			'venues': 'listVenues',
			'venue/:id': 'viewVenue',
			'itinerary/:id': 'viewItinerary',
			'trip/:id': 'viewTrip',
			':screen': 'openScreen',
			'': 'openScreen',
		},

		listCategories: function() {
			openScreen( categoriesList.$el );
		},

		listVenues: function() {
			openScreen( venuesList.$el );
		},

		viewVenue: function( id ) {
			var venue = foundVenues.get( id );
			venueDetails.rebind( venue );
			openScreen( venueDetails.$el );
		},

		viewItinerary: function( id ) {
			var itinerary = viewItinerary.model;

			if ( itinerary.id !== id ) {
				itinerary.clear();
				itinerary.stops.reset();

				viewItinerary.$el.addClass( 'loading' );

				load( id, data => {
					itinerary.set( data );

					var stops = new VenueSet( data.stops );

					getItems( stops.pluck( 'id' ), items => {
						stops.set( items );
						foundVenues.add( stops.models );
						itinerary.stops.reset( stops.models );
					} );
				} );
			}

			openScreen( viewItinerary.$el );
		},

		viewTrip: function( id ) {
			var itinerary = viewItinerary.model;

			if ( itinerary.id !== id ) {
				var trip = myTrips.get( id );

				if ( ! trip ) {
					return alert( 'Unable to load trip' );
				}

				itinerary.clear();
				itinerary.stops.reset();

				viewItinerary.$el.addClass( 'loading' );

				itinerary.set( trip.dump() );

				var stops = new VenueSet();

				getItems( trip.get( 'stops' ), items => {
					stops.set( items );
					foundVenues.add( stops.models );
					itinerary.stops.reset( stops.models );
				} );
			}

			openScreen( viewItinerary.$el );
		},

		openScreen: function( screen ) {
			gotoScreen( screen );
		},
	} ) );

	function openScreen( $screen ) {
		// If going to home, flag as navigating back
		if ( $screen[ 0 ].id === 'home' ) {
			$body.addClass( 'navigating-back' );
		}

		if ( ! $screen.hasClass( 'modal' ) ) {
			$( '.screen.in' ).not( $screen ).hideView();
		}
		$( '.modal.in' ).not( $screen ).hideView();

		$screen.showView( () => $body.removeClass( 'navigating-back' ) );
	}

	function gotoScreen( screen ) {
		screen = screen || 'home';
		screen = screen.replace( '#', '' );

		// Get the target
		var $target = $( document.getElementById( screen ) );

		// If not found, try navigating
		if ( $target.length === 0 ) {
			return router.navigate( screen, { trigger: true } );
		}

		// Open the screen
		openScreen( $target );
	}

	$body.on( 'click', 'a', function( e ) {
		if ( this.target ) {
			return;
		}

		e.preventDefault();
		var path = $( this ).attr( 'href' );
		router.navigate( path, {
			trigger: true,
			replace: $( this ).hasClass( '-replace' ),
		} );
	} );

	$body.on( 'click', '.back', e => {
		e.preventDefault();
		$body.addClass( 'navigating-back' );
		history.back();
	} );

	if ( window.location.hash.indexOf( 'itinerary/' ) < 0 ) {
		window.location.hash = '';
	}
	Backbone.history.start( {
		pushState: false,
	} );

	$( '#view_all' ).click( function() {
		app.trigger( 'filter:category' );
		router.navigate( 'venues', { trigger: true } );
	} );

	$( '#reset' ).click( function() {
		session.set( 'title', null );
		session.stops.reset();
		router.navigate( '', { trigger: true } );
	} );

	// =========================
	// ! Form Submitting
	// =========================

	$body.addClass( 'loading' );
	$( '#home' ).on( 'shown', () => $body.addClass( 'loading' ) );

	$( '#home' ).submit( e => {
		e.preventDefault();

		if ( document.getElementById( 'ask' ) ) {
			session.set( 'ask', document.getElementById( 'ask' ).value );
		}

		categoriesList.collection.each( category => {
			category.set( 'count', 0 );
			category.set( 'venueCount', 0 );
			category.set( 'eventCount', 0 );
		} );

		categoriesList.$el.one( 'shown', () => {
			myVenues.reset( [] );
			session.stops.reset( [] );
			fetchVenues( () => $body.removeClass( 'loading' ) );
		} );

		router.navigate( 'categories', { trigger: true } );

		$( '.screen-body' ).scrollTop( 0 );
	} );

	// =========================
	// ! Expose to app object
	// =========================

	app.router = router;
}
